import React from 'react'
import {
    Box,

    /* Hooks */
    useMultiStyleConfig
} from '@chakra-ui/react'
import PropTypes from 'prop-types'

/* Utils */
import { renderComponentsSwitch } from '../../utils/contentRenderer'

/* Common component */
import CtaBlock from '../../common/ctaBlock'

const FullPanelBlock = ({
    FullPanelBlockCtas,
    ResponsiveBackgroundMedia,
    ...props
}) => {
    const global = useMultiStyleConfig('GlobalCMS', {
        ...props
    })
    const styles = useMultiStyleConfig('FullPanelBlock', {
        ...props
    })

    return (
        <Box {...global.lgContainer} {...styles.container} data-block-type="FullPanelBlock">
            <Box
                {...global.HeroSize}
                {...styles.wrapper}
                sx={{
                    '& [data-block-type="ResponsiveMediaBlock"], [data-block-type="ResponsiveMediaBlock"] div, [data-block-type="ResponsiveMediaBlock"] picture': {
                        width: '100%',
                        height: '100%'
                    },
                    '& img': {
                        width: '100% !important',
                        height: '100% !important',
                        objectFit: 'cover !important'
                    }
                }}
            >
                {renderComponentsSwitch(ResponsiveBackgroundMedia?.Expanded)}
                {FullPanelBlockCtas?.map((cta, index) => {
                    return <CtaBlock
                        key={`CtaBlock-${index}`}
                        {...cta}
                        PreTitleStyle={cta?.FullPanelBlockPreTitleStyle}
                        TitleStyle={cta?.FullPanelBlockTitleStyle}
                        DescriptionStyle={cta?.FullPanelBlockDescriptionStyle}
                        BlockWidth={cta?.FullPanelBlockWidth}
                        ContainerCustomStyling={{
                            paddingBottom: cta?.Alignment === 'center/center' ? 0 : '45px'
                        }}
                        position='absolute'
                    />
                })}
            </Box>
        </Box>
    )
}

FullPanelBlock.propTypes = {
    FullPanelBlockCtas: PropTypes.array,
    ResponsiveBackgroundMedia: PropTypes.object
}

export default FullPanelBlock
